import {Typography} from '@fupa/fupa-uikit/dist/components/typography/Typography';
import React from 'react';
import Faq from '../../faq/Faq';
import {Card, CenteredTypography, Section} from './CardStyles';

const FaqCard = () => {
  return (
    <Section>
      <Card>
        <CenteredTypography variant='headline2' component='h2'>
          FAQs - Häufig gestellte Fragen
        </CenteredTypography>
        <Typography variant='subheading'>
          Du hast Fragen? Hier kannst die Antworten zu den meisten Fragen rund um die Widgets finden. <br />
          Falls du weitere Fragen hast, kannst du uns ganz einfach erreichen. Die Kontaktdaten sind am Ende der Seite
          hinterlegt.
        </Typography>
        <Faq />
      </Card>
    </Section>
  );
};

export default FaqCard;
